import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const StudyMaterialReadSlice = createSlice({
  name: "StudyMaterialReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    studyMaterialRead: (state) => {
      state.isLoading = true;
    },
    successStudyMaterialRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureStudyMaterialRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearStudyMaterialRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  studyMaterialRead,
  successStudyMaterialRead,
  failureStudyMaterialRead,
  clearStudyMaterialRead,
} = StudyMaterialReadSlice.actions;

export default StudyMaterialReadSlice.reducer;
